import {Component} from "@angular/core";
import {ReportType} from "../../objects/report/reportType";
/**
 * Created by alex.y on 9/26/2017.
 */
@Component({
    selector: "report-total-quantity-container",
    templateUrl: "./totalQuantityReport.component.html",
    moduleId: module.id.toString()
})
export class TotalQuantityReportComponent{
    public reportType = ReportType;
}



// WEBPACK FOOTER //
// ./app/components/reports/totalQuantityReport.component.ts